import { forwardRef } from "react";
import { getAlertAssetGridClass } from "./Alert.utils";
import {
  ALERT_WRAPPER_DEFAULT_PROPS,
  TAlertWrapperProps,
} from "./Alert.config";
import { cn } from "@/ui/lib";

export const AlertWrapper = forwardRef<HTMLDivElement, TAlertWrapperProps>(
  (
    {
      children,
      className,
      asset,
      "data-component": component = ALERT_WRAPPER_DEFAULT_PROPS["data-component"],
      ...props
    },
    ref,
  ) => (
    <div
      {...props}
      ref={ref}
      data-component={component}
      className={cn(
        "w-full rounded-sys-sm border border-solid px-4 py-3 shadow-sm",
        "grid gap-x-3 gap-y-1",
        getAlertAssetGridClass(asset),
        className,
      )}
    >
      { children }
    </div>
  ),
);

AlertWrapper.displayName = "AlertWrapper";
